import React from "react";

import { Suggestion } from "chq";
import { useIsMobile } from "app/hooks";
import PostStoryMediaAI from "../prompt-question/PostStoryMediaAI";

type FinalizePageProps = {
  onSuggestionChange: (suggestion: Partial<Suggestion>) => void;
  textStory: Suggestion["story"];
};

const FinalizePage: React.FC<FinalizePageProps> = ({ onSuggestionChange, textStory }) => {
  const isMobile = useIsMobile();

  const handleTextChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    onSuggestionChange({ story: event.target.value });
  };

  return (
    <div className="FinalizePage no-scrollbar">
      {!isMobile && (
        <div className="FinalizePage__Title">
          <h2>Your Final Story</h2>
        </div>
      )}
      <div className="FinalizePage-Container row no-scrollbar">
        <div className="FinalizePage-Container__RightColumn col-xs-12 col-sm-6">
          <PostStoryMediaAI />
        </div>
        <div className="FinalizePage-Container__LeftColumn col-xs-12 col-sm-6">
          <textarea
            className="FinalizePage-Container__Textarea-txt no-scrollbar"
            onChange={handleTextChange}
            value={textStory}
          />
        </div>
      </div>
    </div>
  );
};

export default FinalizePage;
